import { Component, OnInit, Input } from '@angular/core';
import { TableComponent } from "app/components/common/table/table.component";
import { Transform } from 'app/components/common/table/transform';

@Component({
  selector: 'app-table-header',
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.css'],
})
export class TableHeaderComponent implements OnInit {

  constructor(private tableComponent: TableComponent) { }

  @Input()
  private property: string;

  @Input()
  sort: boolean;

  @Input('search')
  searchField: boolean;

  @Input('no-rows')
  private noRows: boolean = false;

  @Input()
  transform?: (data: any) => string;

  private isAsc?: boolean = null;

  private text: string = '';

  private viewSearchBar?: boolean = null;

  ngOnInit() {
    if(!this.noRows){
      this.tableComponent.addProperties(this.property);
      if(this.transform != undefined && this.transform != null){
        let t = new Transform();
        t.property = this.property;
        t.transform = this.transform;
        this.tableComponent.addTransform(t);
      }
    }
  }

  toggleSearchBar(){
    this.viewSearchBar = !this.viewSearchBar;
  }

  public search(): void{
    this.tableComponent.search({ value: this.text, property: this.property });
  }

  public orderBy(): void{
    this.tableComponent.setCurrentOrdered(this);

    if(this.isAsc!=null){
      this.isAsc = (this.isAsc ? !this.isAsc : null);
      if(this.isAsc === null) {
        this.tableComponent.setDefaultOrder();
      } else {
        this.tableComponent.orderBy(this.property, this.isAsc);
      }
    }
    else{
      this.isAsc = true;
      this.tableComponent.orderBy(this.property, this.isAsc);
    }
  }

  public getProperty(): string {
    return this.property;
  }

  public setIsAsc(isAsc: boolean): void {
    this.isAsc = isAsc;
  }
}
